export interface ShippingData {
  shippingDay: string;
  shippingStartDay?: string;
  publicHolidays: string[];
}
export function calculateShippingDate(shippingData: ShippingData): Date {
    const singaporeTime = new Date().toLocaleString("en-US", { timeZone: "Asia/Singapore" });
    const today = new Date(singaporeTime);
    const shippingDays = parseInt(shippingData.shippingDay, 10);

  // Convert public holidays to Date objects
  const holidays: Date[] = shippingData.publicHolidays.map((date) => {
    const [year, month, day] = [
      date.slice(0, 4),
      date.slice(4, 6),
      date.slice(6, 8),
    ];
    return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
  });

  let currentDate = new Date(today);
  let daysAdded = 0;

  while (daysAdded < shippingDays) {
    currentDate.setDate(currentDate.getDate() + 1);
    if (
      currentDate.getDay() !== 0 &&
      currentDate.getDay() !== 6 &&
      !isHoliday(currentDate, holidays)
    ) {
      daysAdded++;
    }
  }

  // Add 2 more days if the calculated date falls on a weekend
  if (currentDate.getDay() === 0 || currentDate.getDay() === 6) {
    currentDate.setDate(currentDate.getDate() + 2);
  }

  // Check if the new date is a holiday, if so, move to the next business day
  while (
    isHoliday(currentDate, holidays) ||
    currentDate.getDay() === 0 ||
    currentDate.getDay() === 6
  ) {
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return currentDate;
}

export function calculateShippingStartDate(shippingData: ShippingData): string {
    const singaporeTime = new Date().toLocaleString("en-US", { timeZone: "Asia/Singapore" });
    const today = new Date(singaporeTime);
    const shippingStartDays = parseInt(shippingData?.shippingStartDay ?? "0", 10);

  // Convert public holidays to Date objects
  const holidays: Date[] = shippingData.publicHolidays.map((date) => {
    const [year, month, day] = [
      date.slice(0, 4),
      date.slice(4, 6),
      date.slice(6, 8),
    ];
    return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
  });

  let currentDate = new Date(today);
  let daysAdded = 0;

  while (daysAdded < shippingStartDays) {
    currentDate.setDate(currentDate.getDate() + 1);
    if (
      currentDate.getDay() !== 0 &&
      currentDate.getDay() !== 6 &&
      !isHoliday(currentDate, holidays)
    ) {
      daysAdded++;
    }
  }

  // Add 2 more days if the calculated date falls on a weekend
  if (currentDate.getDay() === 0 || currentDate.getDay() === 6) {
    currentDate.setDate(currentDate.getDate() + 2);
  }

  // Check if the new date is a holiday, if so, move to the next business day
  while (
    isHoliday(currentDate, holidays) ||
    currentDate.getDay() === 0 ||
    currentDate.getDay() === 6
  ) {
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return currentDate.toLocaleString("en-US", { month: "short", day: "numeric" });
}

export function calculateShippingEndDate(shippingData: ShippingData): string {
    const singaporeTime = new Date().toLocaleString("en-US", { timeZone: "Asia/Singapore" });
    const today = new Date(singaporeTime);
    const shippingDays = parseInt(shippingData?.shippingDay ?? "0", 10);

  // Convert public holidays to Date objects
  const holidays: Date[] = shippingData.publicHolidays.map((date) => {
    const [year, month, day] = [
      date.slice(0, 4),
      date.slice(4, 6),
      date.slice(6, 8),
    ];
    return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
  });

  let currentDate = new Date(today);
  let daysAdded = 0;

  while (daysAdded < shippingDays) {
    currentDate.setDate(currentDate.getDate() + 1);
    if (
      currentDate.getDay() !== 0 &&
      currentDate.getDay() !== 6 &&
      !isHoliday(currentDate, holidays)
    ) {
      daysAdded++;
    }
  }

  // Add 2 more days if the calculated date falls on a weekend
  if (currentDate.getDay() === 0 || currentDate.getDay() === 6) {
    currentDate.setDate(currentDate.getDate() + 2);
  }

  // Check if the new date is a holiday, if so, move to the next business day
  while (
    isHoliday(currentDate, holidays) ||
    currentDate.getDay() === 0 ||
    currentDate.getDay() === 6
  ) {
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return currentDate.toLocaleString("en-US", { month: "short", day: "numeric" });
}


function isHoliday(date: Date, holidays: Date[]): boolean {
  return holidays.some(
    (holiday) =>
      holiday.getFullYear() === date.getFullYear() &&
      holiday.getMonth() === date.getMonth() &&
      holiday.getDate() === date.getDate(),
  );
}

export function formatDataDate(data: number): Date {

    const year = Math.floor(data / 10000);
    const month = Math.floor((data % 10000) / 100) - 1;
    const day = data % 100;
    const date = new Date(year, month, day);
    return date;
}


export function formatDate(date: Date): string {
  const day = date.getDate();
  const month = date.toLocaleString("default", { month: "long" });
  const year = date.getFullYear();

  const suffix = getDaySuffix(day);

  return `${day}${suffix} ${month} ${year}`;
}

function getDaySuffix(day: number): string {
  if (day > 3 && day < 21) return "th";
  switch (day % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
}
